import { render } from "./loadingComponent.vue?vue&type=template&id=50655ab1"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/loadingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50655ab1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50655ab1', __exports__)) {
    api.reload('50655ab1', __exports__)
  }
  
  module.hot.accept("./loadingComponent.vue?vue&type=template&id=50655ab1", () => {
    api.rerender('50655ab1', render)
  })

}


export default __exports__